import afffirmationsScreen from '../../../public/webp/fromPNG/rumblefish23Theme/afffirmationsScreen.webp';
import deathCharadesScreen from '../../../public/webp/fromPNG/rumblefish23Theme/deathCharadesScreen.webp';
import devaWalletSingleScreen from '../../../public/webp/fromPNG/rumblefish23Theme/devaWalletSingleScreen.webp';
import verifiIdScreen from '../../../public/webp/fromPNG/rumblefish23Theme/verifiIdScreen.webp';

export const mobileServicesData = {
  mainText:
    'We create apps that inspire, perform highly, and look stunning. No matter the platform or device your customers use.',
  description: `
    We use React Native to develop high-end apps for both iOS and Android platforms. 
    You don’t need any mobile development expertise - just let us know what you 
    want your app to do, and we’ll take care of how to make it happen!
  `,
  services: [
    {
      title: 'iOS native app development',
      description: `
        At Rumble Fish, we specialize in creating exceptional iOS native apps that deliver 
        outstanding performance and user experience. Our team of seasoned developers is adept 
        at leveraging the full potential of the iOS platform to build apps that are not 
        only visually stunning but also highly functional and secure.
        <br />
        When you choose Rumble Fish for your iOS native app development, you’re choosing 
        a partner committed to excellence. We take the time to understand your business 
        goals and user needs, ensuring that every app we develop is perfectly aligned with 
        your vision. From intuitive user interfaces to seamless integration with the latest 
        iOS features, our focus is on creating an app that stands out in the crowded marketplace.
        <br />
        At Rumble Fish, we pride ourselves on our collaborative approach. We act as your advisor 
        and mentor throughout the development process, providing expert guidance and support. 
        Whether you’re launching a new app or enhancing an existing one, we have the expertise 
        to turn your ideas into reality. With our commitment to innovation and quality, 
        we’ll help you create a mobile experience that truly resonates with your users.
      `,
      src: devaWalletSingleScreen,
      imageAlt: 'deva-wallet-screen',
    },
    {
      title: 'Android native app development',
      description: `
        Unlock the full potential of the Android platform with Rumble Fish’s Android native 
        app development services. Our experienced developers are dedicated to creating 
        high-performing, beautiful apps tailored to meet your unique business needs.
        <br />
        Security and reliability are paramount in our development process. We employ 
        advanced security measures to protect your Android app from vulnerabilities, 
        ensuring your users' data is safe and secure. Our apps are designed to 
        be fast, responsive, and capable of handling the demands of a growing user base.
        <br />
        What sets us apart is our collaborative approach. We work closely with you throughout 
        the development journey, offering insights and expertise to help refine your vision. 
        <br />
        Rumble Fish delivers more than just an app; we provide a comprehensive solution 
        that meets your business objectives and exceeds user expectations. With our 
        focus on innovation and quality, we’ll help you create an Android app 
        that truly resonates with your audience and drives your business forward.
      `,
      src: afffirmationsScreen,
      imageAlt: 'afffirmations-screen',
    },
    {
      title: 'Cross-platform mobile app development',
      description: `
        Expand your reach with Rumble Fish’s cross-platform mobile app development 
        services. Our mobile development team specializes in creating versatile 
        apps that deliver a seamless user experience across both iOS and 
        Android devices, ensuring maximum impact with minimal effort.
        <br />
        At Rumble Fish, we understand the importance of consistency and performance 
        across different platforms. Our cross-platform apps are designed to provide a 
        unified user experience, maintaining high standards of functionality and 
        aesthetics regardless of the device. Using React Native, we ensure that 
        your app looks and performs flawlessly on any platform.
        <br />
        Partnering with Rumble Fish means more than just developing an app; it 
        means gaining a dedicated team that’s invested in your success. With our 
        innovative approach and commitment to quality, we’ll help you create 
        a cross-platform mobile app that engages users and drives business growth.
      `,
      src: verifiIdScreen,
      imageAlt: 'verifi-id-screen',
    },
    {
      title: 'Mobile UI/UX design services',
      description: `
        At Rumble Fish, we understand that a great UI/UX can make or break your digital 
        product success. After all, you never have a second chance to make a great first 
        impression. That’s why having a smooth user experience is so crucial for your 
        brand - you only have one chance to make your customers fall in love with your app! 
        <br />
        Mobile UI/UX design plays a pivotal role in the success of your custom mobile product. 
        In today's fast-paced world, users expect nothing short of seamless, intuitive 
        experiences across all their devices. At Rumble Fish, we recognize the importance 
        of staying ahead of these expectations. Our dedicated team of designers and developers 
        collaborate closely to create mobile interfaces that wow the audience. From 
        wireframing and prototyping to final implementation, we employ industry best 
        practices and the latest design trends to deliver solutions that stand out in the 
        crowded app market. With a keen understanding of user behavior and interaction 
        patterns, we ensure that every element of your mobile UI/UX is optimized for performance 
        and user delight. Whether you're launching a new app or revamping an existing one, 
        trust Rumble Fish to transform your ideas into unforgettable mobile experiences.
      `,
      src: deathCharadesScreen,
      imageAlt: 'death-charades-screen',
    },
  ],
};
